<template>
    <div class="address">
        <Head
            :headInfo='headInfo'
            @onClickLeft='onBack'
        />
        <div class="container">
            <div class="isSelect">
                <div class="item-left" @click="onAddOrder()" >
                    <input class="doRadio" type="checkbox" name="sex" :checked="!checkCouponData.length">
                    <label></label>
                </div>
                <div class="item-right">
                    不使用优惠券
                </div>
            </div>
            <div class="content" v-if="effectList.length || exprieList.length">
                <EffectTempate
                    v-for="item in effectList"
                    :effectData='item'
                    :key="item.id"
                    @onAddOrder='onAddOrder(item)'
                />
                <div class="headTitle" v-show="exprieList.length">以下优惠券不满足使用条件</div>
                <EffectTempate
                    v-for="item in exprieList"
                    :effectData='item'
                    :stop='true'
                    :key="item.id"
                />
            </div>
            <div class="msg" v-else>
                <img src="../../../assets/img/b2b/img_empty_coupons@2x.png" alt="">
                暂无优惠券
            </div>
        </div>
        <div class="foot">
            <p>已选中{{ checkCouponData.length }}张，共优惠{{ totalPrice | NumFormat }}元</p>
            <div class="btn" @click="onSubmit">确认</div>
        </div>
    </div>
</template>
<script>
import { getCouponList, getUseCoupon } from '../api/activity'
import { mapActions } from 'vuex'
import EffectTempate from './component/effectTemplate'
import Head from '../../common/head'
import { Toast } from 'vant'
export default {
    name: 'invoice',
    components: {
        Head,
        EffectTempate
    },
    props: {
        getCouponData: {
            type: null,
            default: null
        }
    },
    data () {
        return {
            headInfo: {
                title: '选择优惠券'
            },
            invoiceListId: '', // 判断是否选中
            activityId: '',
            userInfo: '',
            scure: 0,
            invoiceList: [],
            couponCheck: true,
            checkCouponData: [], // 选中的优惠券
            selectAddressBack: '',
            effectData: '',
            selectNum: [],
            selectPrice: 0,
            productList: [],
            effectList: [],
            exprieList: [],
            couponList: [], // 选中的数组
            csList: []
        }
    },
    computed: {
        // 计算金额
        totalPrice () {
            let price = this.checkCouponData.reduce((acc, cur) => {
                return acc + cur.actualDiscount
            }, 0)
            return price
        }
    },
    methods: {
        ...mapActions(['setBuried']),
        onBack () {
            // if (this.checkCouponData.length !== this.couponList.length) {
            //     this.setCouponStatus(true)
            // }
            this.$emit('getCouponBack')
            // this.$router.replace({ path: this.selectAddressBack })
        },
        onAddOrder (item) {
            this.buryPoint(68)
            if (item) {
                item.exprieCheck = !item.exprieCheck
            } else {
                this.effectList.forEach(item => {
                    item.exprieCheck = false
                })
            }
            this.checkCouponList()
        },
        onSubmit () {
            this.checkCouponList()
            let item = {
                activityId: this.getCouponData.activityId,
                couponArr: this.checkCouponData,
                productList: this.getCouponData.productList,
                totalAmount: this.getCouponData.totalAmount
            }
            // console.log(item)
            let data = {
                checkCouponData: this.checkCouponData,
                item: item
            }
            this.$emit('getCouponBack', data)
            // this.setCouponInfo({
            //     activityId: this.getCouponData.activityId,
            //     couponArr: this.checkCouponData,
            //     productList: this.getCouponData.productList,
            //     totalAmount: this.getCouponData.totalAmount
            // })
            // this.$router.replace({ path: '/b2b/order/confirmOrder' })
        },
        // 获取优惠券列表
        async getCouponList () {
            const { data } = await getCouponList({
                merchantCode: this.getCouponData.merchantCode,
                activityId: this.getCouponData.activityId,
                memberCode: this.userInfo.companyCode,
                productList: this.getCouponData.productList,
                totalAmount: this.getCouponData.totalAmount,
                inquiryId: this.$route.query.inquiryId
            })
            if (!data) {
                return false
            }
            let effectList = data.effectList
            // 默认选中的值
            effectList.length && effectList.forEach(item => {
                item.exprieCheck = false
                item.isBuy = true
                this.couponList.forEach(it => {
                    if (item.couponDetailId === it.couponDetailId) {
                        item.exprieCheck = true
                        item.isBuy = true
                    }
                })
            })
            this.effectList = effectList
            this.exprieList = data.exprieList
            this.checkCouponList()
        },
        // 已选中的优惠券
        checkCouponList () {
            let checkCouponData = this.effectList.filter(item => item.exprieCheck)
            if (checkCouponData.length === 2) {
                this.effectList.forEach(item => {
                    if (!item.exprieCheck) {
                        item.isBuy = false
                    }
                })
                this.getUseCouponData()
            } else if (checkCouponData.length === 1) {
                this.getUseCouponData()
            } else {
                this.effectList.forEach(item => {
                    item.exprieCheck = false
                    item.isBuy = true
                })
            }
            this.checkCouponData = checkCouponData
        },
        async getUseCouponData () {
            let conponIds = [] // 获取全部可用优惠券的couponId
            let couponList = [] // 获取可用优惠券的id和code
            let selectCouponId = [] // 选中优惠券的couponDetailId
            this.effectList.forEach(item => {
                if (!(conponIds.includes(item.couponId))) {
                    conponIds.push(item.couponId)
                }
                if (item.exprieCheck) {
                    selectCouponId.push(item.couponDetailId)
                }
                couponList.push({ id: item.couponDetailId, couponCode: item.couponCode })
            })
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            const { data } = await getUseCoupon({
                couponIds: conponIds,
                details: couponList,
                selectedCouponDetailIds: selectCouponId,
                orderBo: this.getCouponData
            })
            Toast.clear()
            let availableIds = data.availableIds
            let actualInfo = data.actualInfo
            this.handlerCount(availableIds)
            this.handlerCountPrice(actualInfo.data)
        },
        // 获取可用优惠券是否显示计算
        handlerCount (arr1) {
            let map = {}
            for (let i = 0; i < arr1.length; i++) {
                map[arr1[i]] = true
            }
            return this.effectList.map((item) => {
                if (map[item.couponDetailId] || item.exprieCheck) {
                    item.isBuy = true
                } else {
                    item.isBuy = false
                }
                return item
            })
        },
        // 获取实际优惠券金额
        handlerCountPrice (arr) {
            let map = {}
            for (let i = 0; i < arr.length; i++) {
                map[arr[i]['couponDetailId']] = arr[i]['actualDiscount']
            }
            return this.effectList.map((item) => {
                item.actualDiscount = 0
                if (item.exprieCheck && map[item.couponDetailId]) {
                    item.actualDiscount = map[item.couponDetailId]
                }
                return item
            })
        },
        buryPoint (event) {
            this.setBuried({ event: event })
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.selectAddressBack = localStorage.getItem('orderConfirm')
        this.couponList = this.getCouponData.couponArr
        this.getCouponList()
    }
}
</script>
<style lang="scss" scoped>
    .h150{
        height: 300px;
    }
    .address {
        font-size: 28px;
        color: #000000;
        background: #f5f5f5;
        height: 100%;
        overflow: hidden;
        .container {
            height: calc(100% - 270px);
            overflow: auto;
        }
        .isSelect{
            display: flex;
            justify-content: flex-start;
            position: relative;
            padding: 40px 32px;
            background: #ffffff;
            .item-left{
                margin-right: 10px;
                input{
                    position: absolute
                }
            }
        }
        .content {
            padding: 20px 24px 0 32px;
            position: relative;
        }
        .headTitle{
            text-align: center;
            margin: 40px 0;
            font-size: 28px;
            color: #333333;
        }
        .msg{
            width: 250px;
            font-size: 26px;
            color: #c7c7cc;
            margin: 0 auto;
            padding-top: 160px;
            text-align: center;
            img{
                width: 176px;
                height: 176px;
                margin: 0 auto;
                display: block;
            }
        }
        .foot{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: #ffffff;
            .btn{
                background: #FF7A45;
                height: 96px;
                line-height: 96px;
                font-size: 34px;
                color: #ffffff;
                text-align: center;
                border-radius: 96px;
                margin: 16px 32px;
            }
            p{
                padding: 10px 0;
                text-align: center;
                font-size: 24px;
                background: rgba(250, 249, 249, 0.5);
            }
        }
    }
</style>
